function createSlider(wrapper) { 
    const carousel = wrapper.querySelector(".FC-list-slider-init");
    const arrowBtns = wrapper.querySelectorAll(".FC-list-slider__btn");
    const firstCardWidth = carousel.querySelector(".FC-list-slider__slide").offsetWidth;
    const carouselChildrens = [...carousel.children];
    
    let isDragging = false,
    	isAutoPlay = true,
    	startX,
    	startScrollLeft,
    	timeoutId;
    
    // Get the number of cards that can fit in the carousel at once
    let cardPerView = Math.round(carousel.offsetWidth / firstCardWidth);
    
    // Add event listeners for the arrow buttons to scroll the carousel left and right
    arrowBtns.forEach((btn) => {
    	btn.addEventListener("click", () => {
    		carousel.scrollLeft += btn.id == "left" ? -firstCardWidth : firstCardWidth;
    	});
    });
    
    const dragStart = (e) => {
    	isDragging = true;
    	carousel.classList.add("dragging");
    	// Records the initial cursor and scroll position of the carousel
    	startX = e.pageX;
    	startScrollLeft = carousel.scrollLeft;
    };
    
    const dragging = (e) => {
    	if (!isDragging) return; // if isDragging is false return from here
    	// Updates the scroll position of the carousel based on the cursor movement
    	carousel.scrollLeft = startScrollLeft - (e.pageX - startX);
    };
    
    const dragStop = () => {
    	isDragging = false;
    	carousel.classList.remove("dragging");
    };
    const autoPlay = () => {
    	if (window.innerWidth < 800 || !isAutoPlay) return; // Return if window is smaller than 800 or isAutoPlay is false
    	// Autoplay the carousel after every 2500 ms
    	timeoutId = setTimeout(() => (carousel.scrollLeft += firstCardWidth), 2500);
    };
    //autoPlay();

    //document.addEventListener("mouseup", dragStop);
   wrapper.addEventListener("mouseenter", () => clearTimeout(timeoutId));

    carousel.addEventListener("mousedown", (e) => {
      dragStart(e, carousel);
    });

  carousel.addEventListener("mousemove", (e) => {
      dragging(e, carousel);
    });

  carousel.addEventListener("mouseup", (e) => {
      dragStop(e, carousel);
    });

  
}
